import { ExternalLink } from 'lucide-react';

interface AttributionProps {
  className?: string;
}

export function Attribution({ className = '' }: AttributionProps) {
  return (
    <a 
      href="https://www.paulsmith.codes" 
      target="_blank" 
      rel="noopener noreferrer" 
      className={`text-sm text-jamaica-green hover:text-jamaica-green/80 flex items-center transition-colors duration-200 ${className}`}
    >
      Developed by PaulSmith.Codes <ExternalLink className="ml-1 h-3 w-3" />
    </a>
  );
} 